module.exports = __webpack_public_path__ + "img/title_0.a0201cda.png";